import { DrawdownStatus } from 'modules/project'
import {RequestStatus as Status0} from '.'


export type DrawdownRequestStatus = Status0 | 'document-check' | 'received' | 'confirmed'

/**
 * drawdown审核状态 常量定义
 * 从上到下对应后端drawdown的审核状态的顺序
 */
export const DRAWDOWNSTATUS: Record<string, DrawdownStatus> = {
  DOCUMENT_CHECK: 'document-check',
  FINAL_APPROVAL: 'final-approval',
  CONFIRMED: 'confirmed',
  APPROVED: 'approved',
  RECEIVED: 'received',
  DECLINED: 'declined'
}

// 前后端drawdown状态的映射关系
export const DRAWDOWN_REQUEST_STATUS_NAME: Record<DrawdownRequestStatus, string> = {
  'document-check': 'Lending manager review',
  'final-approval': 'FC Review',
  confirmed: 'Drawdown confirm',
  approved: 'Pending payment',
  received: 'Paid',
  declined: 'Declined drawdown',

  created: 'Loan request created',
  'loans-coordinator-check': 'Loans coordinator check',
  'lending-manager-check': 'Lending manager check',
  'financial-controller-check': 'Financial controller check',
  'director-check': 'Director approval',
  'aml-check': 'AML check',
  'ready-to-open': 'Ready to open',
  opened: 'Opened request',
}
